import React from 'react';

function CzToolTipInfoComponent(props: any) {
    return <div className={props.className}>{props.value}</div>;
}

export default CzToolTipInfoComponent;
